module.exports = __webpack_public_path__ + "img/quick-help.81a9df0b.svg";